export function designImageUrl(design) {
  if (!design) return "";
  return (
    design.image_url ||
    design.imageUrl ||
    design.image ||
    design.url ||
    design.thumbnail_url ||
    design.thumbnailUrl ||
    ""
  );
}

export function bookingDesign(booking) {
  const generated = Array.isArray(booking?.request?.generated) ? booking.request.generated : [];
  return booking?.request?.final_design || generated.find((d) => designImageUrl(d)) || generated[0] || {};
}
